import React, { createContext, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ShortcutContext = createContext(null);

export const ShortcutProvider = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.metaKey && !event.shiftKey && !event.altKey) {
        switch (event.key.toLowerCase()) {
          case 'e':
            event.preventDefault();
            navigate('/expense?quickAdd=true');
            break;
          case 'n':
            event.preventDefault();
            navigate('/notes?quickAdd=true');
            break;
          case 'r':
            event.preventDefault();
            navigate('/routine?quickAdd=true');
            break;
          case 't':
            event.preventDefault();
            navigate('/tweek');
            break;
          case 'd':
            event.preventDefault();
            navigate('/dashboard');
            break;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  return <ShortcutContext.Provider value={null}>{children}</ShortcutContext.Provider>;
};
